import type { BestNextMoveBundle, ProjectProgressSnapshot } from '../contracts/types'
import { BNM_ORBIS } from './bestNextMoveOrbis'
import { BNM_VISITOR } from './bestNextMoveVisitor'
import { PROGRESS_ORBIS } from './progressOrbis'

export const EMPTY_MISSION_ID = 'none' as const
export const ORBIS_MISSION_ID = 'orbis' as const

export const EMPTY_MISSION_PROGRESS: ProjectProgressSnapshot = {
  projectId: EMPTY_MISSION_ID,
  projectName: 'No active mission',
  projectType: 'film_story',
  currentFocusStageId: 'signal_captured',
  summary: {
    readyCount: 0,
    totalCountable: 0,
    headline: 'Start or select a mission to begin',
  },
  spine: [],
  markers: [],
}

export const EMPTY_MISSION_BNM: BestNextMoveBundle = {
  generatedAt: '2026-06-02T00:00:00.000Z',
  primary: {
    recommendationId: 'bnm-empty-mission-01',
    category: 'pathway_education',
    title: 'Start or select a mission',
    summary:
      'Open Guided Studio or choose a project to activate mission control, progress orbit, and surface recommendations.',
    whyThisMatters:
      'Mission control stays neutral until a project is selected so progress and risk stay honest.',
    riskIfIgnored: 'No production handoff risk until a mission exists.',
    suggestedSurface: 'none',
    suggestedAction: 'Start or select a mission',
    priority: 'high',
    confidence: 'high',
    humanConfirmationRequired: false,
    allowedActions: ['start', 'defer', 'dismiss'],
    forbiddenActions: [
      'auto_execute',
      'auto_publish',
      'auto_handoff',
      'auto_advance_stage',
      'sign_in',
      'create_account',
      'launch_app',
    ],
    affectedProjectId: EMPTY_MISSION_ID,
    blockersAddressed: [],
  },
}

export const HELD_MISSION_PROGRESS: ProjectProgressSnapshot = {
  ...EMPTY_MISSION_PROGRESS,
  summary: {
    readyCount: 0,
    totalCountable: 0,
    headline: 'Mission control interiors require an active grant',
  },
}

export const MISSION_CATALOG: Record<
  string,
  { progress: ProjectProgressSnapshot; bestNextMove: BestNextMoveBundle }
> = {
  [ORBIS_MISSION_ID]: {
    progress: PROGRESS_ORBIS,
    bestNextMove: BNM_ORBIS,
  },
}

export function getMissionPreset(missionId: string | null | undefined): {
  progress: ProjectProgressSnapshot
  bestNextMove: BestNextMoveBundle
} {
  if (!missionId || missionId === EMPTY_MISSION_ID) {
    return { progress: EMPTY_MISSION_PROGRESS, bestNextMove: EMPTY_MISSION_BNM }
  }
  return MISSION_CATALOG[missionId] ?? { progress: EMPTY_MISSION_PROGRESS, bestNextMove: EMPTY_MISSION_BNM }
}

export { BNM_VISITOR, BNM_ORBIS, PROGRESS_ORBIS }
